import { dynamicLoader } from '~/utils';

export const AddressEditor = dynamicLoader({
  name: 'AddressEditorWrapper',
  importFunc: () => import('./address-editor-wrapper'),
});

export const AddressDisplay = dynamicLoader({
  name: 'AddressDisplay',
  importFunc: () => import('./address-display'),
});

export const AddressEditForm = dynamicLoader({
  name: 'AddressEditForm',
  importFunc: () => import('./address-edit-form'),
});